// import DownMouse from "../components/downMouse";
// import pin from "../static files/images/pin.png";
// import hours from "../static files/images/working-hours.png";
// import instagram from "../static files/images/instagram.png";
// import linkedin from "../static files/images/linkedin-big-logo.png";
// import tiktok from "../static files/images/tik-tok.png";
// import { useDispatch, useSelector } from "react-redux";
// import { sendMessage } from "../slices/contactReducer";
// const Contact = () => {
//   const { data, status, error } = useSelector((state) => state.contact);
//   const dispatch = useDispatch();
//   const handleSubmit = () => {
//     dispatch(
//       sendMessage({
//         fullName: "",
//         phoneNumber: "",
//         email: "",
//         selectedService: "",
//         serviceInfo: "",
//       })
//     );
//   };
//   return (
//     <main>
//       <section className="contact-hero">
//         <div className="section-body">
//           <h1>Əlaqə</h1>
//           <h2>Biz kömək etmək üçün buradayıq</h2>
//           <div className="down-mouse">
//             <DownMouse />
//           </div>
//           <div className="work-hours">
//             <div className="section-one">
//               <img src={pin} alt="pin" />
//               <h3>
//                 <span>İş saatları :</span> <br />
//                 <br /> B.e-C.a : 08:30 – 17:00 Şənbə-Bazar: Bağlıdır
//               </h3>
//             </div>
//             <div className="section-two">
//               <img src={hours} alt="pin" />
//               <h3>
//                 <span>Ünvan :</span> <br />
//                 <br />
//                 9VR6+X87, Karabagh Street, Baku
//               </h3>
//             </div>
//           </div>

//           <div className="phone-number">
//             <div className="section-one">
//               <h3>
//                 <span>Telefon Nömrəsi:</span> +994 (50) 256 22 11
//               </h3>
//               <span>info@azglass.com</span>
//             </div>
//             <div className="section-two">
//               <ul>
//                 <li>
//                   <a href="tiktok.com" className="image-box">
//                     <img src={tiktok} alt="tiktok" />
//                   </a>
//                 </li>
//                 <li>
//                   <a href="linkedin.com" className="image-box">
//                     <img src={linkedin} alt="linkedin" />
//                   </a>
//                 </li>
//                 <li>
//                   <a
//                     href="https://instagram.com"
//                     target="__blank"
//                     className="image-box"
//                   >
//                     <img src={instagram} alt="instagram" />
//                   </a>
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </div>

//         <iframe
//           src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1659.649211303713!2d49.85986073375978!3d40.39249117023704!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40307d152bd7d73b%3A0x92a47a0852f48752!2zOTUgUWFyYWJhxJ8ga8O8w6fJmXNpLCBCYWvEsQ!5e0!3m2!1saz!2saz!4v1758971556771!5m2!1saz!2saz"
//           width="600"
//           height="450"
//           allowfullscreen=""
//           loading="lazy"
//           referrerpolicy="no-referrer-when-downgrade"
//         ></iframe>
//       </section>

//       <section className="form-section">
//         <div className="header">
//           <div className="line-horizontal"></div>
//           <div className="header-text">
//             <div className="circle"></div>
//             <h3>Əlaqə saxlayın</h3>
//             <div className="line-vertical"></div>
//           </div>
//         </div>

//         <div className="section-body">
//           <h2>
//             Formanı doldurun, komandamız sizinlə tezliklə əlaqə saxlayacaq.
//           </h2>
//           <form>
//             <div className="name-surname">
//               <div className="text-box">
//                 <label htmlFor="name">Ad Soyad</label>
//                 <input name="name" type="text" placeholder="Ad Soyad" />
//               </div>
//               <div className="text-box">
//                 <label htmlFor="email">Email</label>
//                 <input type="email" placeholder="example@gmail.com" required />
//               </div>
//             </div>

//             <div className="phone">
//               <div className="text-box">
//                 <label htmlFor="phone">Telefon</label>
//                 <input
//                   type="tel"
//                   name="phone"
//                   onInput={(e) => {
//                     e.target.value = e.target.value.replace(/\D/g, ""); // yalnız rəqəm saxlayır
//                   }}
//                   placeholder="+994 50 123 45 67"
//                   pattern="^\+994\s\d{2}\s\d{3}\s\d{2}\s\d{2}$"
//                   required
//                 />
//               </div>
//               <div className="text-box">
//                 <label htmlFor="service">Maraqlandığınız Xidmətlər</label>
//                 <input
//                   name="service"
//                   type="text"
//                   placeholder="Maraqlandığınız Xidmətlər"
//                 />
//               </div>
//             </div>

//             <div className="message">
//               <div className="text-box">
//                 <label htmlFor="message">Mesaj</label>
//                 <input
//                   name="message"
//                   type="text"
//                   placeholder="Sizə necə kömək edə bilərik ?"
//                 />
//               </div>
//             </div>

//             <button type="submit">Göndər</button>
//           </form>
//         </div>
//       </section>
//     </main>
//   );
// };

// export default Contact;

import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sendMessage } from "../slices/contactReducer";

import DownMouse from "../components/downMouse";
import pin from "../static files/images/pin.png";
import hours from "../static files/images/working-hours.png";
import instagram from "../static files/images/instagram.png";
import linkedin from "../static files/images/linkedin-big-logo.png";
import tiktok from "../static files/images/tik-tok.png";

const Contact = () => {
  const dispatch = useDispatch();
  const { data, status, error } = useSelector((state) => state.contact);

  // Form state
  const [formData, setFormData] = useState({
    fullName: "",
    phoneNumber: "",
    email: "",
    selectedService: "",
    serviceInfo: "",
  });

  // Input change handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(sendMessage(formData));
    // Opsiyonel: formu temizlemek
    setFormData({
      fullName: "",
      phoneNumber: "",
      email: "",
      selectedService: "",
      serviceInfo: "",
    });
  };

  return (
    <main>
      <section className="contact-hero">
        <div className="section-body">
          <h1>Əlaqə</h1>
          <h2>Biz kömək etmək üçün buradayıq</h2>
          <div className="down-mouse">
            <DownMouse />
          </div>
          <div className="work-hours">
            <div className="section-one">
              <img src={pin} alt="pin" />
              <h3>
                <span>İş saatları :</span> <br />
                <br /> B.e-Ş : 10:00 – 17:00
              </h3>
            </div>
            <div className="section-two">
              <img src={hours} alt="pin" />
              <h3>
                <span>Ünvan :</span> <br />
                <br />
                9VR6+X87, Karabagh Street, Baku
              </h3>
            </div>
          </div>

          <div className="phone-number">
            <div className="section-one">
              <h3>
                <span>Telefon Nömrəsi:</span> +994 (50) 256 22 11
              </h3>
              <span>info@azglass.com</span>
            </div>
            <div className="section-two">
              <ul>
                <li>
                  <a href="tiktok.com" className="image-box">
                    <img src={tiktok} alt="tiktok" />
                  </a>
                </li>
                <li>
                  <a href="linkedin.com" className="image-box">
                    <img src={linkedin} alt="linkedin" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://instagram.com"
                    target="__blank"
                    className="image-box"
                  >
                    <img src={instagram} alt="instagram" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1659.649211303713!2d49.85986073375978!3d40.39249117023704!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40307d152bd7d73b%3A0x92a47a0852f48752!2zOTUgUWFyYWJhxJ8ga8O8w6fJmXNpLCBCYWvEsQ!5e0!3m2!1saz!2saz!4v1758971556771!5m2!1saz!2saz"
          width="600"
          height="450"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </section>

      <section className="form-section">
        <div className="header">
          <div className="line-horizontal"></div>
          <div className="header-text">
            <div className="circle"></div>
            <h3>Əlaqə saxlayın</h3>
            <div className="line-vertical"></div>
          </div>
        </div>

        <div className="section-body">
          <h2>
            Formu doldurun, komandamız sizinlə tezliklə əlaqə saxlayacaq.
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="name-surname">
              <div className="text-box">
                <label htmlFor="fullName">Ad Soyad</label>
                <input
                  name="fullName"
                  type="text"
                  placeholder="Ad Soyad"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="text-box">
                <label htmlFor="email">Email</label>
                <input
                  name="email"
                  type="email"
                  placeholder="example@gmail.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="phone">
              <div className="text-box">
                <label htmlFor="phoneNumber">Telefon</label>
                <input
                  type="tel"
                  name="phoneNumber"
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, "");
                  }}
                  placeholder="+994 50 123 45 67"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="text-box">
                <label htmlFor="selectedService">
                  Maraqlandığınız Xidmətlər
                </label>
                <input
                  name="selectedService"
                  type="text"
                  placeholder="Maraqlandığınız Xidmətlər"
                  value={formData.selectedService}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="message">
              <div className="text-box">
                <label htmlFor="serviceInfo">Mesaj</label>
                <input
                  name="serviceInfo"
                  type="text"
                  placeholder="Sizə necə kömək edə bilərik ?"
                  value={formData.serviceInfo}
                  onChange={handleChange}
                />
              </div>
            </div>

            <button type="submit" disabled={status === "loading"}>
              {status === "loading" ? "Göndərilir..." : "Göndər"}
            </button>
            {status === "succeeded" && <p>Mesajınız uğurla göndərildi ✅</p>}
            {status === "failed" && <p>Xəta: {error}</p>}
          </form>
        </div>
      </section>
    </main>
  );
};

export default Contact;
